import { useEffect, useState } from 'react'
import { extractMessageFromServiceError } from '../services/error.service'

/**
 * ApiFn can be any Promise fn; in our
 * case it will be a feathers application service object
 * that returns a promise
 */
export const useFetch = <
  T,
  Args = void | string | number | Record<string, unknown>
>(
  ApiFn: (args?: Args) => Promise<T>,
  args?: Args
) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<T | null>(null)
  const [error, setError] = useState<string>('')

  const fetchData = async (): Promise<void> => {
    try {
      setLoading(true)
      const data = args ? await ApiFn(args) : await ApiFn()
      setData(data)
    } catch (err) {
      setError(extractMessageFromServiceError(err))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, data, error } as const
}
